import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone:true,
  name: 'bytesConversion'
})
export class BytesConversionPipe implements PipeTransform {
  private units : Array<string> = ['B','KB','MB', 'GB', 'TB'];
  transform(value: any, decimal?:number, valueInUnits?: any): any {
      value = Number(value)
      if(window.location.pathname == '/'){ // to prevent this pipe to load when left menu is being loaded on about page when user is logged in
        return
      }
      let unit = 0;
      let precision:number;
      while ( value >= 1024 && unit < 4) {
        value /= 1024;
        unit ++;
      }
      precision= unit == 0 ? 0 : decimal!= null && decimal!= undefined? decimal: 2;
      if(value != null && value != "") {
        value = value ==0 ? value.toFixed(precision) : value.toFixed(precision); 
        if(value % 1 == 0) {
          value =  Math.trunc(value);
        }
      }
      if(value == 0){
        unit = 1;
      }
      return value  + ' ' + this.units[unit];
  }

}
